import { FACILITY_TAB } from './../../utils/constants/enums';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface TabState {
  facilityTab: FACILITY_TAB;
}

const initialState: TabState = {
  facilityTab: FACILITY_TAB.FACILITY,
};

const tabSlice = createSlice({
  name: 'tab',
  initialState,
  reducers: {
    setFacilityTab(state, action: PayloadAction<FACILITY_TAB>) {
      state.facilityTab = action.payload;
    },
  },
});

export const { setFacilityTab } = tabSlice.actions;
export default tabSlice.reducer;
